document.addEventListener('DOMContentLoaded', () => {
    const dialog = document.querySelector('#sortPanel');
    const openButton = document.querySelector('.collectionTopActionsOpen');
    const closeButton = document.querySelector('.closeSortPanel');

    if (!dialog) return;

    // 🔄 Collapse all filter panels on load
    document.querySelectorAll('.filterHeading').forEach(button => {
        button.setAttribute('aria-expanded', 'false');
        button.nextElementSibling.classList.remove('open');
    });

    // 📂 Set up toggle handlers
    document.querySelectorAll('.filterHeading').forEach(button => {
        button.addEventListener('click', () => {
            const expanded = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', !expanded);
            button.nextElementSibling.classList.toggle('open');
        });
    });

    // Polyfill support for older browsers (optional)
    if (typeof dialog.showModal !== 'function' && typeof dialogPolyfill !== 'undefined') {
        dialogPolyfill.registerDialog(dialog);
    }

    const openSortPanel = () => {
        if (!dialog.open) {
            dialog.showModal();
            dialog.classList.add('open');
            document.body.classList.add('noScroll');
        }
    };

    const closeSortPanel = () => {
        if (dialog.open) {
            dialog.classList.remove('open');
            setTimeout(() => dialog.close(), 300);
            document.body.classList.remove('noScroll');
        }
    };

    openButton?.addEventListener('click', openSortPanel);
    closeButton?.addEventListener('click', closeSortPanel);

    dialog.addEventListener('click', (e) => {
        if (e.target === dialog) closeSortPanel();
    });

    dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        closeSortPanel();
    });
});
